module.exports = __webpack_public_path__ + "img/feature-7.2a0c9b98.png";